/* Blog share actions.
   These were <a href="#"> and did nothing: clicking "LinkedIn" or "Copy link"
   scrolled to the top. They resolve the current URL at runtime so they keep
   working on any domain or staging host. */
(function () {
  'use strict';

  var row = document.querySelector('.post-share, .share-row, [class*="share"]');
  if (!row) return;

  var url = location.href.split('#')[0];
  var title = (document.querySelector('h1') || {}).textContent || document.title;

  function label(el) {
    return (el.textContent || '').trim().toLowerCase();
  }

  Array.prototype.forEach.call(row.querySelectorAll('a[href="#"], button'), function (el) {
    var kind = label(el);

    if (kind.indexOf('linkedin') > -1) {
      el.setAttribute('href', 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(url));
      el.setAttribute('target', '_blank');
      el.setAttribute('rel', 'noopener');
      return;
    }
    if (kind.indexOf('twitter') > -1 || kind === 'x') {
      el.setAttribute('href', 'https://twitter.com/intent/tweet?url=' +
        encodeURIComponent(url) + '&text=' + encodeURIComponent(title.trim()));
      el.setAttribute('target', '_blank');
      el.setAttribute('rel', 'noopener');
      return;
    }
    if (kind.indexOf('copy') > -1) {
      el.removeAttribute('href');
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      var original = el.innerHTML;
      var done = function () {
        el.innerHTML = 'Link copied';
        setTimeout(function () { el.innerHTML = original; }, 2000);
      };
      var copy = function (e) {
        e.preventDefault();
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, fallback);
        } else { fallback(); }
      };
      var fallback = function () {
        var t = document.createElement('textarea');
        t.value = url; t.setAttribute('readonly', '');
        t.style.cssText = 'position:absolute;left:-9999px';
        document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); done(); } catch (err) { /* nothing to do */ }
        document.body.removeChild(t);
      };
      el.addEventListener('click', copy);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') copy(e);
      });
    }
  });
})();
